<template>
  <div v-show="isActive">
    <slot />
  </div>
</template>
    
<script>
export default {
  name: 'Tab',	
  props: {
    name: { 
      type: String,
      default: '',
      required: true
    },
    selected: { 
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isActive: false
    };
  },
  mounted () {
    this.isActive = this.selected;
  }
}
</script>
